<style lang="scss">
@media only screen and (max-width: 768px) {
  /* This part is only read by viewports wider than 1200 pixels */
  .i-sidebar{
    display: none;
  }
  .main-content{
    padding:25px !important;
    box-shadow: none !important;
  }
  .doc{
    margin: 5px !important;
  }
}

.doc{
  & .text-success{
    color:teal !important;
    font-weight: 600;
  }
  & .text-danger{
    font-weight: 600;
  }
  word-spacing: -.5px;
  letter-spacing: .2px;
  font-family: 'Manrope';
  font-size: 14px;
  font-weight: 500;
  color:#4e4e4e !important;
  &-nav{
    &-title{
      color: rgb(151, 151, 151);
      font-size: 13px;
    }
    &-section{
      font-weight: 500;
      color: rgb(121, 121, 121);
    }
  }
  &-section{
    margin-bottom:20px;
    border-bottom: 1px solid #e4e4e4 ;

    
  }
  &-subsection{
    font-size: 14px;

    &-link{
      font-weight: 500;
    }
  }
  & h1{
    margin-bottom: 0px !important;
    line-height: 1.5 !important;
  }
  & h2{
    margin-bottom: 5px !important;
    line-height: 1.2 !important;
  }
  & h3{
    margin-bottom: 5px !important;
    line-height: 1.2 !important;
  }
  h5{
    margin-bottom: 10px !important;
    line-height: 1.2 !important;
  }
  & p{
    letter-spacing: .2px;
    line-height: 1.5;
    font-size: 14px;
  }
  & .table-wrapper{
    overflow: hidden;
    border-radius: 4px;
    border: 1px solid teal;
  }
  & table{
    font-size: 13px;
    & th{
      font-weight: 600;
    }
    & td{
      color: #303030;
    }
  }
  & .table-bordered{
    border-style: hidden;
    border-collapse:collapse;
    border-spacing: 0;
    margin:0;
    overflow-x: hidden;
    & th{
      color: white;
      background-color: teal;
      font-weight: 600;
      font-size: 13px;
    }
    & td{
      color: #505050;
      padding: 8px 8px !important;
      font-size: 13px;
      
    }
    & th, & td{
      border: 1px solid rgb(11, 141, 141);
      padding-left: 8px !important;
      padding-right: 8px !important;
    }
    & td.info{
      background-color: rgb(238, 238, 238);
      font-size: 12px;
    }
  }

  & .list-group-item{
    font-size: 13px;
    // border-left: 2px solid rgb(209, 209, 209);
    // border-right: none;
    // border-top: none;
    // border-bottom: none;
    border:none;
    border-radius: 0;
    color:rgb(134, 134, 134);
    background: transparent;

    &.menu{
      padding: 3px 10px;
    }
    &.submenu{
      padding: 0 10px;
    }
  }
  & .list-group-item.active{
    
    background: transparent;
    color: rgb(33, 146, 33);
    font-weight: 500;
    // border-left: 2px solid rgb(0, 136, 136);
    font-weight: 700;
    &.menu{
      margin: 4px 0 0 0 !important;
    }
    & .menu-icon{
      font-size: 15px;
      font-weight: 500;
      color: white;
      background: linear-gradient(135deg, rgb(44, 173, 44) 0%, rgb(33, 146, 33) 52%);
      
    }
  }
}
.main-content{
  padding-top:25px;
  padding-right:130px;
  padding-left:60px;
  // box-shadow: rgba(0, 0, 0, 0.04) 0px 3px 5px;
}
.i-sidebar{
  font-family: 'Manrope';
  padding-left:55px;
  padding-right:25px;
  background-color: #ffffff;
  & .menu, & .submenu{
    display: flex;
    align-items: center;
  }
  & .menu{
    margin: 4px 0 0 0;
     &-empty{
       border-right: 1px solid rgb(236, 236, 236);
       min-height: 25px;
       max-height: 25px;
       width:13px;
       min-width:13px;
       margin-right: 20px;
     }
     &-icon{
       height: 25px;
       min-height: 25px;
       max-height: 25px;
       width:25px;
       min-width:25px;
       margin-right: 8px;

       font-weight: 500;
       font-size:15px;
       
       background-color: #ffffff;
       border: 1px solid rgb(221, 221, 221);
       border-radius:4px;
       display: flex;
       justify-content: center;
       align-items: center;
       
     }
  }
}
</style>
<template>
  <div id="sds-doc" class="doc">
    <div class="content__breadcrumbs">
      <Breadcrumbs :items="breadcrumbs"></Breadcrumbs>
    </div>
    <b-row style="min-height:100vh">
      <b-col cols="auto" class="i-sidebar ">
        <div style="position:sticky;top:85px">
          <b-list-group v-b-scrollspy="150">
            <b-list-group-item href="#selamat-datang" v-on:click="scrollIntoView" class="menu">
              <i class="ri-home-5-line menu-icon" ></i>Selamat Datang
            </b-list-group-item>
            <b-list-group-item href="#alur-sds" @click="scrollIntoView" class="menu">
              <i class="ri-git-branch-line menu-icon"></i>Alur Standar Data Statistik
            </b-list-group-item>

            <b-list-group-item href="#konsep" @click="scrollIntoView" class="menu">
              <i class="ri-sun-line menu-icon"></i>Konsep
            </b-list-group-item>
            <b-list-group-item href="#atribut-konsep" class="submenu" @click="scrollIntoView">
              <span class="menu-empty"></span> Atribut
            </b-list-group-item>
            <b-list-group-item href="#rekomendasi-konsep" class="submenu" @click="scrollIntoView">
               <span class="menu-empty"></span> Rekomendasi Pengusulan
            </b-list-group-item>

            <b-list-group-item href="#variabel" @click="scrollIntoView" class="menu">
              <i class="ri-apps-line menu-icon"></i>Variabel
            </b-list-group-item>
            <b-list-group-item href="#atribut-variabel" class="submenu" @click="scrollIntoView">
              <span class="menu-empty"></span> Atribut
            </b-list-group-item>
            <b-list-group-item href="#rekomendasi-variabel" class="submenu" @click="scrollIntoView">
              <span class="menu-empty"></span> Rekomendasi Pengusulan
            </b-list-group-item>

            <b-list-group-item href="#indikator" @click="scrollIntoView" class="menu">
              <i class="ri-bubble-chart-line menu-icon"></i> Indikator
            </b-list-group-item>
            <b-list-group-item href="#atribut-indikator" class="submenu" @click="scrollIntoView">
              <span class="menu-empty"></span>Atribut
            </b-list-group-item>
            <b-list-group-item href="#rekomendasi-indikator" class="submenu" @click="scrollIntoView">
              <span class="menu-empty last-child"></span>Rekomendasi Pengusulan
            </b-list-group-item>
            
            <b-list-group-item href="#lampiran" @click="scrollIntoView" class="menu">
              <i class="ri-file-copy-2-line menu-icon"></i>Lampiran
            </b-list-group-item>
            <b-list-group-item href="#lampiran-ukuran" class="submenu" @click="scrollIntoView">
              <span class="menu-empty"></span> Ukuran
            </b-list-group-item>
            <b-list-group-item href="#lampiran-subyek" class="submenu" @click="scrollIntoView">
              <span class="menu-empty"></span> Subyek
            </b-list-group-item>

            
          </b-list-group>
        </div>
      </b-col>
      <b-col class="main-content">

        <b-row class="d-flex i-text-12 mb-3" style="color:#878787">
          <b-col>Dokumentasi Penggunaan Standar Data Statistik v1.0</b-col>
          <b-col cols="auto">Last Update: 3 Februari 2022</b-col>
        </b-row>

        <div style="position:relative; overflow-y:auto;overflow-x:hidden" ref="content" >
          <div class="doc-section p-0">
            <h2 id="selamat-datang">Selamat Datang</h2>
            <p style="text-align:justify">
              Halaman ini berisikan panduan penggunaan, pengusulan, dan pemeriksaan Standar Data Statistik di sistem <span class="font-weight-bold" style="color:green">Indonesia Data Hub (INDAH).</span> Panduan ini diharapkan dapat memberikan kemudahan bagi pengguna dalam menggunakan aplikasi dan juga memberikan pemahaman terkait istilah-istilah yang digunakan dalam Standar Data Statistik
            </p>
          </div>
          <div class="doc-section"> 
            <div>
              <h3 id="konsep">Konsep</h3>
              <p>
                Konsep adalah ide yang mendasari data dan tujuan data tersebut diproduksi (Peraturan Badan Pusat Statistik Nomor 4 Tahun 2020). Dalam pengajuan usulan baru maupun pemutakhiran konsep terdapat beberapa atribut yang perlu diisi oleh pengusul, yaitu:
              </p>
              <div class="table-wrapper" id="atribut-konsep">
                <b-table-simple bordered>
                  <b-thead>
                    <b-tr>
                      <b-th class="text-left" style="width:100px">Atribut</b-th>
                      <b-th class="text-left" >Deskripsi</b-th>
                    </b-tr>
                  </b-thead>
                  <b-tbody>
                    <b-tr style="border-color:#e9e9e9 !important">
                      <b-td>Nama<span style="color:red">*</span></b-td>
                      <b-td>Nama konsep dapat dituangkan ke dalam satu kata tunggal, gabungan beberapa kata (frase) ataupun suatu kalimat lengkap</b-td>
                    </b-tr>
                    <b-tr style="border-color:#e9e9e9 !important">
                      <b-td>Definisi<span style="color:red">*</span></b-td>
                      <b-td>
                        Deskripsi mengenai konsep yang dapat memberikan batas atau membedakan secara jelas arti dan cakupan suatu konsep dengan konsep yang lain
                      </b-td>
                    </b-tr>
                    <b-tr style="border-color:#e9e9e9 !important">
                      <b-td>Referensi<span style="color:red">*</span></b-td>
                      <b-td>
                        Sumber referensi yang digunakan terkait dengan konsep yang diusulkan, referensi bisa berasal dari publikasi, website maupun lainnya
                      </b-td>
                    </b-tr>
                    <b-tr class="">
                      <b-td colspan="2" class="info"><span style="color:red">*</span> Atribut yang wajib terisi</b-td>
                    </b-tr>
                  </b-tbody>
                </b-table-simple>
              </div>
            </div>
            <div id="rekomendasi-konsep" class="mt-4">
              <h5>Rekomendasi Pengusulan Konsep</h5>
              <b-table-simple borderless>
                <b-tbody>
                  <b-tr class="" style="border-color:#e9e9e9 !important">
                    <b-td style="width:20px">1.</b-td>
                    <b-td>
                      <b-row class="mb-2">
                        <b-col>
                          <span class="font-weight-bold">Setiap awalan kata nama konsep harus huruf besar</span>
                        </b-col>
                      </b-row>
                      <b-row>
                        <b-col cols="auto" class="pr-0">
                          <VueFeather type="check" size="18" stroke="green" stroke-width="3" style="margin-bottom:2px"></VueFeather>
                        </b-col>
                        <b-col class="pl-1">Rumah Tangga</b-col>
                      </b-row>
                      <b-row>
                        <b-col cols="auto" class="pr-0">
                          <VueFeather type="x" size="18" stroke="red" stroke-width="3" style="margin-bottom:2px"></VueFeather>
                        </b-col>
                        <b-col class="pl-1">rumah tangga</b-col>
                      </b-row>
                    </b-td>
                  </b-tr>

                  <b-tr class="" style="border-color:#e9e9e9 !important">
                    <b-td style="width:20px">2.</b-td>
                    <b-td>
                      <b-row class="mb-2">
                        <b-col>
                          <span class="font-weight-bold">Nama Konsep harus unik.</span><br> 
                          Dari nama konsep harus dapat dibedakan antara suatu konsep dengan konsep yang lain
                        </b-col>
                      </b-row>
                      <b-row>
                        <b-col cols="auto" class="pr-0">
                          <VueFeather type="check" size="18" stroke="green" stroke-width="3" style="margin-bottom:2px"></VueFeather>
                        </b-col>
                        <b-col class="pl-1">Rumah Tangga</b-col>
                      </b-row>
                      <b-row>
                        <b-col cols="auto" class="pr-0">
                          <VueFeather type="x" size="18" stroke="red" stroke-width="3" style="margin-bottom:2px"></VueFeather>
                        </b-col>
                        <b-col class="pl-1">Lainnya, sebaiknya konsep ini diganti dengan nama konsep yang lebih jelas dan unik</b-col>
                      </b-row>
                    </b-td>
                  </b-tr>

                  <b-tr class="" style="border-color:#e9e9e9 !important">
                    <b-td style="width:20px">3.</b-td>
                    <b-td>
                      <b-row class="mb-2">
                        <b-col>
                          <span class="font-weight-bold">Nama konsep tidak boleh disingkat.</span><br>
                          Pemberian singkatan sebaiknya diberikan hanya jika singkatan tersebut bersifat umum dan merepresentasikan nama konsep secara menyeluruh
                        </b-col>
                      </b-row>
                      <b-row>
                        <b-col cols="auto" class="pr-0">
                          <VueFeather type="check" size="18" stroke="green" stroke-width="3" style="margin-bottom:2px"></VueFeather>
                        </b-col>
                        <b-col class="pl-1">Nomor Pokok Wajib Pajak</b-col>
                      </b-row>
                      <b-row>
                        <b-col cols="auto" class="pr-0">
                          <VueFeather type="check" size="18" stroke="green" stroke-width="3" style="margin-bottom:2px"></VueFeather>
                        </b-col>
                        <b-col class="pl-1">Nomor Pokok Wajib Pajak (NPWP)</b-col>
                      </b-row>
                      <b-row>
                        <b-col cols="auto" class="pr-0">
                          <VueFeather type="x" size="18" stroke="red" stroke-width="3" style="margin-bottom:2px"></VueFeather>
                        </b-col>
                        <b-col class="pl-1">NPWP</b-col>
                      </b-row>
                      <b-row>
                        <b-col cols="auto" class="pr-0">
                          <VueFeather type="x" size="18" stroke="red" stroke-width="3" style="margin-bottom:2px"></VueFeather>
                        </b-col>
                        <b-col class="pl-1">Jaminan Pensiun <span class="text-danger">(JP)</span> : Singkatan tidak bersifat umum</b-col>
                      </b-row>
                    </b-td>
                  </b-tr>

                  <b-tr class="" style="border-color:#e9e9e9 !important">
                    <b-td style="width:20px">4.</b-td>
                    <b-td>
                      <b-row class="mb-2">
                        <b-col>
                          <span class="font-weight-bold">Nama konsep tidak boleh diawali ukuran.</span><br> Contoh ukuran dapat dilihat di <a href="#lampiran-ukuran">lampiran berikut</a>
                        </b-col>
                      </b-row>
                      <b-row>
                        <b-col cols="auto" class="pr-0">
                          <VueFeather type="check" size="18" stroke="green" stroke-width="3" style="margin-bottom:2px"></VueFeather>
                        </b-col>
                        <b-col class="pl-1">Konsumsi Makanan</b-col>
                      </b-row>
                      <b-row>
                        <b-col cols="auto" class="pr-0">
                          <VueFeather type="x" size="18" stroke="red" stroke-width="3" style="margin-bottom:2px"></VueFeather>
                        </b-col>
                        <b-col class="pl-1"><span class="text-danger">Rata-rata </span> Konsumsi Makanan Selama Sebulan</b-col>
                      </b-row>
                    </b-td>
                  </b-tr>

                  <b-tr class="" style="border-color:#e9e9e9 !important">
                    <b-td style="width:20px">5.</b-td>
                    <b-td>
                      <b-row class="mb-2">
                        <b-col>
                          <span class="font-weight-bold">Nama konsep tidak boleh memuat periode tertentu.</span> <br> 
                          Jika konsep disandingkan dengan periode tertentu akan berpotensi menimbulkan beberapa konsep yang berulang/duplikat, secara konteks merupakan konsep yang sama namun dituliskan dalam periode yang berbeda-beda.
                        </b-col>
                      </b-row>
                      <b-row>
                        <b-col cols="auto" class="pr-0">
                          <VueFeather type="check" size="18" stroke="green" stroke-width="3" style="margin-bottom:2px"></VueFeather>
                        </b-col>
                        <b-col class="pl-1">Konsumsi Makanan</b-col>
                      </b-row>
                      <b-row>
                        <b-col cols="auto" class="pr-0">
                          <VueFeather type="x" size="18" stroke="red" stroke-width="3" style="margin-bottom:2px"></VueFeather>
                        </b-col>
                        <b-col class="pl-1">Konsumsi Makanan <span class="text-danger">selama sebulan</span> </b-col>
                      </b-row>
                      <b-row>
                        <b-col cols="auto" class="pr-0">
                          <VueFeather type="x" size="18" stroke="red" stroke-width="3" style="margin-bottom:2px"></VueFeather>
                        </b-col>
                        <b-col class="pl-1">Konsumsi Makanan <span class="text-danger">selama setahun</span> </b-col>
                      </b-row>
                      <b-row>
                        <b-col cols="auto" class="pr-0">
                          <VueFeather type="x" size="18" stroke="red" stroke-width="3" style="margin-bottom:2px"></VueFeather>
                        </b-col>
                        <b-col class="pl-1">Konsumsi Makanan <span class="text-danger">seminggu yang lalu</span> </b-col>
                      </b-row>
                    </b-td>
                  </b-tr>

                  <b-tr class="" style="border-color:#e9e9e9 !important">
                    <b-td style="width:20px">6.</b-td>
                    <b-td>
                      <b-row class="mb-2">
                        <b-col>
                          <span class="font-weight-bold">Nama konsep tidak memuat wilayah/cakupan wilayah tertentu.</span> <br> 
                          Jika konsep disandingkan dengan wilayah/cakupan wilayah tertentu akan berpotensi menimbulkan beberapa konsep yang berulang/duplikat, secara konteks merupakan konsep yang sama namun dituliskan dalam wilayah/cakupan wilayah yang berbeda-beda.
                        </b-col>
                      </b-row>
                      <b-row>
                        <b-col cols="auto" class="pr-0">
                          <VueFeather type="check" size="18" stroke="green" stroke-width="3" style="margin-bottom:2px"></VueFeather>
                        </b-col>
                        <b-col class="pl-1">Nilai Konsumsi Dasar Barang dan Jasa yang terpilih sebagai Paket Komoditas</b-col>
                      </b-row>
                      <b-row>
                        <b-col cols="auto" class="pr-0">
                          <VueFeather type="x" size="18" stroke="red" stroke-width="3" style="margin-bottom:2px"></VueFeather>
                        </b-col>
                        <b-col class="pl-1">Nilai Konsumsi Dasar Barang dan Jasa yang terpilih sebagai Paket Komoditas <span class="text-danger">di 90 Kota IHK</span> </b-col>
                      </b-row>
                      <b-row>
                        <b-col cols="auto" class="pr-0">
                          <VueFeather type="x" size="18" stroke="red" stroke-width="3" style="margin-bottom:2px"></VueFeather>
                        </b-col>
                        <b-col class="pl-1">Harga Konsumen Beberapa Bahan Pokok <span class="text-danger">di Ibukota Provinsi Seluruh Indonesia</span> </b-col>
                      </b-row>
                    </b-td>
                  </b-tr>

                  <b-tr class="" style="border-color:#e9e9e9 !important">
                    <b-td style="width:20px">7.</b-td>
                    <b-td>
                      <b-row class="mb-2">
                        <b-col>
                          <span class="font-weight-bold">Penulisan referensi disesuaikan dengan jenis sumbernya.</span> Jika berasal dari website maka inputkan URL websitenya, jika publikasi maka tuliskan judul publikasinya (lebih baik jika dapat menyertakan halamannya)
                        </b-col>
                      </b-row>
                      <b-row>
                        <b-col cols="auto" class="pr-0">
                          <VueFeather type="check" size="18" stroke="green" stroke-width="3" style="margin-bottom:2px"></VueFeather>
                        </b-col>
                        <b-col class="pl-1">
                          <b-row>
                            <b-col cols="auto" class="word-wrap-break-all pr-0">https://sirusa.bps.go.id/sirusa/index.php/istilah/index </b-col>
                            <b-col cols="auto"><span class="i-badge i-badge-primary">website</span></b-col>
                          </b-row>
                        </b-col>
                      </b-row>
                      <b-row>
                        <b-col cols="auto" class="pr-0">
                          <VueFeather type="check" size="18" stroke="green" stroke-width="3" style="margin-bottom:2px"></VueFeather>
                        </b-col>
                        <b-col class="pl-1">
                          <b-row>
                            <b-col cols="auto" class="pr-0">Indikator Tujuan Pembangunan Berkelanjutan Indonesia 2021 (hlm. 123-129)</b-col>
                            <b-col cols="auto"><span class="i-badge i-badge-secondary">publikasi</span></b-col>
                          </b-row>
                        </b-col>
                      </b-row>
                      <b-row>
                        <b-col cols="auto" class="pr-0">
                          <VueFeather type="x" size="18" stroke="red" stroke-width="3" style="margin-bottom:2px"></VueFeather>
                        </b-col>
                        <b-col class="pl-1">
                          <b-row>
                            <b-col cols="auto" class="pr-0">Website BPS</b-col>
                            <b-col cols="auto" ><span class="i-badge i-badge-secondary">website</span></b-col>
                          </b-row>
                        </b-col>
                      </b-row>
                    </b-td>
                  </b-tr>
                </b-tbody>
              </b-table-simple>
            </div>
          </div>

          <div class="doc-section">
            <h3 id="variabel">Variabel</h3>
            <p>
              <span class="font-weight-bold">Menurut Peraturan Badan Pusat Statistik Nomor 4 Tahun 2020, </span> Variabel adalah suatu informasi yang ingin ditangkap dalam menghasilkan data pada Kegiatan Statistik.
            </p>

            <p>
              Dari sumber yang lain, Variabel didefinisikan sebagai  penggunaan konsep sebagai karakteristik dari populasi yang ingin diukur (Generic Statistical Information Model). Dalam pengajuan usulan baru maupun pemutakhiran variabel terdapat beberapa atribut yang perlu diisi oleh pengusul, yaitu:
            </p>
            <div class="table-wrapper" id="atribut-variabel">
              <b-table-simple bordered>
                <b-thead>
                  <b-tr>
                    <b-th class="text-left" style="width:140px">Atribut</b-th>
                    <b-th class="text-left" >Deskripsi</b-th>
                  </b-tr>
                </b-thead>
                <b-tbody>
                  <b-tr style="border-color:#e9e9e9 !important">
                    <b-td>Nama<span style="color:red">*</span></b-td>
                    <b-td>Nama variabel dapat dituangkan ke dalam satu kata tunggal, gabungan beberapa kata (frase) ataupun suatu kalimat lengkap</b-td>
                  </b-tr>
                  <b-tr style="border-color:#e9e9e9 !important">
                    <b-td>Definisi<span style="color:red">*</span></b-td>
                    <b-td>
                      Deskripsi variabel dapat memberikan batasan atau membedakan secara jelas arti dan cakupan dari suatu variabel dengan variabel yang lain
                    </b-td>
                  </b-tr>
                  <b-tr style="border-color:#e9e9e9 !important">
                    <b-td>Konsep<span style="color:red">*</span></b-td>
                    <b-td>
                      Konsep yang digunakan sebagai dasar pembentukan variabel
                    </b-td>
                  </b-tr>
                  <b-tr style="border-color:#e9e9e9 !important">
                    <b-td>Unit observasi<span style="color:red">*</span></b-td>
                    <b-td>
                      Digunakan untuk menggambarkan jenis atau kelompok unit observasi yang diukur oleh variabel. Variabel berperan sebagai karakteristik yang dimiliki oleh unit observasi. Contoh: Pada variabel umur maka jenis atau kelompok unit observasinya adalah individu karena karakteristik umur adalah sesuatu yang dimiliki oleh seseorang.
                    </b-td>
                  </b-tr>
                  <b-tr style="border-color:#e9e9e9 !important">
                    <b-td>Ukuran</b-td>
                    <b-td>
                      Ukuran statistik yang digunakan untuk mengukur variabel seperti jumlah, rata-rata dan lainnya. Ukuran lainnya dapat dilihat di <a href="#lampiran-ukuran">lampiran berikut</a>
                    </b-td>
                  </b-tr>
                  <b-tr style="border-color:#e9e9e9 !important">
                    <b-td>Satuan</b-td>
                    <b-td>
                      Satuan adalah unit yang digunakan dalam pengukuran variabel. Satuan harus bersesuaian dengan ukuran yang digunakan. Contoh satuan persen digunakan untuk ukuran persentase. Contoh lainnya dapat dilihat di <a href="#lampiran-ukuran">lampiran berikut</a>
                    </b-td>
                  </b-tr>
                  <b-tr style="border-color:#e9e9e9 !important">
                    <b-td>Subyek<span style="color:red">*</span></b-td>
                    <b-td>
                      Digunakan untuk mengelompokkan variabel berdasarkan kategori tertentu. Referensi kategori yang digunakan bersumber dari <i>Classification of Statistical Activities (CSA rev.1)</i>, adapun rincian kategori tersebut dapat dilihat di <a href="#lampiran-ukuran">lampiran berikut</a>
                    </b-td>
                  </b-tr>
                  <b-tr style="border-color:#e9e9e9 !important">
                    <b-td>Jenis value domain<span style="color:red">*</span></b-td>
                    <b-td>
                      Value domain adalah rentang nilai dari isian variabel yang diperbolehkan. Jenis value domain ada dua:
                      <b-row>
                        <b-col cols="auto" class="pr-0">1.</b-col>
                        <b-col class="pl-1">
                          <span class="font-weight-bold">Non-kategori</span><br> adalah jenis value domain yang nilainya tidak dinyatakan sebagai daftar kode dan kategori. Contohnya umur yang nilai 0-99 atau jumlah pengeluaran yang nilainya berupa angka riil.
                        </b-col>
                      </b-row>
                      <b-row>
                        <b-col cols="auto" class="pr-0">2.</b-col>
                        <b-col class="pl-1">
                          <span class="font-weight-bold">Kategori</span><br> adalah jenis value domain yang nilai dinyatakan sebagai daftar kode dan kategori <i>(CodeList)</i>. <br>
                          Contoh: variabel jenis kelamin, maka value domainnya adalah Laki-laki (L) dan Perempuan (P)
                        </b-col>
                      </b-row>
                    </b-td>
                  </b-tr>
                  <b-tr style="border-color:#e9e9e9 !important">
                    <b-td>Referensi klasifikasi<span style="color:red">*</span></b-td>
                    <b-td>
                      Adalah nama klasifikasi standar yang digunakan sebagai dasar rujukan penentuan value domain variabel yang berjenis kategori.
                    </b-td>
                  </b-tr>
                  <b-tr style="border-color:#e9e9e9 !important">
                    <b-td>Aturan validasi<span style="color:red">*</span></b-td>
                    <b-td>
                      Penjelasan deskriptif terkait ekspresi matematis atau logika tertentu yang digunakan sebagai validasi suatu variabel. Contoh: aturan validasi untuk variabel usia : bilang bulat minimal 0 dan maksimal 99.
                    </b-td>
                  </b-tr>
                  <b-tr style="border-color:#e9e9e9 !important">
                    <b-td>Sumber referensi yang digunakan<span style="color:red">*</span></b-td>
                    <b-td>
                      Sumber referensi yang digunakan terkait dengan variabel yang diusulkan, referensi bisa berasal dari publikasi, website maupun lainnya
                    </b-td>
                  </b-tr>
                  <b-tr class="">
                    <b-td colspan="2" class="info"><span style="color:red">*</span> Atribut yang wajib terisi</b-td>
                  </b-tr>
                </b-tbody>
              </b-table-simple>
            </div>
            <div id="rekomendasi-variabel" class="mt-4">
              <h5>Rekomendasi Pengusulan Variabel</h5>
              <b-table-simple borderless>
                <b-tbody>
                  <b-tr class="" style="border-color:#e9e9e9 !important">
                    <b-td style="width:20px">1.</b-td>
                    <b-td>
                      <b-row class="mb-2">
                        <b-col>
                          <span class="font-weight-bold">Setiap awalan kata nama variabel harus huruf besar</span>
                        </b-col>
                      </b-row>
                      <b-row>
                        <b-col cols="auto" class="pr-0">
                          <VueFeather type="check" size="18" stroke="green" stroke-width="3" style="margin-bottom:2px"></VueFeather>
                        </b-col>
                        <b-col class="pl-1">Jenis Kelamin</b-col>
                      </b-row>
                      <b-row>
                        <b-col cols="auto" class="pr-0">
                          <VueFeather type="x" size="18" stroke="red" stroke-width="3" style="margin-bottom:2px"></VueFeather>
                        </b-col>
                        <b-col class="pl-1">jenis kelamin</b-col>
                      </b-row>
                    </b-td>
                  </b-tr>

                  <b-tr class="" style="border-color:#e9e9e9 !important">
                    <b-td style="width:20px">2.</b-td>
                    <b-td>
                      <b-row class="mb-2">
                        <b-col>
                          <span class="font-weight-bold">Nama variabel harus unik.</span><br>
                          Dari nama variabel harus dapat dibedakan antara suatu variabel dengan variabel yang lain. Jika terdapat variabel yang merupakan variasi dari suatu variabel lain, maka nama variabel tersebut bisa ditambahkan suatu konteks sehingga dapat membedakan variabel tersebut dengan variabel utamanya 
                        </b-col>
                      </b-row>
                      <b-row>
                        <b-col cols="auto" class="pr-0">
                          <VueFeather type="check" size="18" stroke="green" stroke-width="3" style="margin-bottom:2px"></VueFeather>
                        </b-col>
                        <b-col class="pl-1">Kelompok umur</b-col>
                      </b-row>
                      <b-row>
                        <b-col cols="auto" class="pr-0">
                          <VueFeather type="check" size="18" stroke="green" stroke-width="3" style="margin-bottom:2px"></VueFeather>
                        </b-col>
                        <b-col class="pl-1">Kelompok umur pendidikan</b-col>
                      </b-row>
                      
                    </b-td>
                  </b-tr>

                  <b-tr class="" style="border-color:#e9e9e9 !important">
                    <b-td style="width:20px">3.</b-td>
                    <b-td>
                      <b-row class="mb-2">
                        <b-col>
                          <span class="font-weight-bold">Nama variabel tidak boleh disingkat.</span> <br>Pemberian singkatan sebaiknya diberikan hanya jika singkatan bersifat umum.
                        </b-col>
                      </b-row>
                      <b-row>
                        <b-col cols="auto" class="pr-0">
                          <VueFeather type="check" size="18" stroke="green" stroke-width="3" style="margin-bottom:2px"></VueFeather>
                        </b-col>
                        <b-col class="pl-1">Tanggal Daftar Nomor Pokok Wajib Pajak (NPWP)</b-col>
                      </b-row>
                      <b-row>
                        <b-col cols="auto" class="pr-0">
                          <VueFeather type="check" size="18" stroke="green" stroke-width="3" style="margin-bottom:2px"></VueFeather>
                        </b-col>
                        <b-col class="pl-1">Tanggal Daftar NPWP</b-col>
                      </b-row>
                    </b-td>
                  </b-tr>

                  <b-tr class="" style="border-color:#e9e9e9 !important">
                    <b-td style="width:20px">4.</b-td>
                    <b-td>
                      <b-row class="mb-2">
                        <b-col>
                          <span class="font-weight-bold">Unit observasi variabel boleh lebih dari satu.</span><br>
                          Selama variabel memang merupakan karakteristik dari berapa unit observasi maka diperbolehkan suatu variabel memiliki beberapa unit observasi.
                        </b-col>
                      </b-row>
                      <b-row>
                        <b-col cols="auto" class="pr-0">
                          <VueFeather type="check" size="18" stroke="green" stroke-width="3" style="margin-bottom:2px"></VueFeather>
                        </b-col>
                        <b-col class="pl-1">Jika variabelnya adalah Jumlah Transaksi Electronic Commerce (E-Commerce), maka Unit observasi yang diperbolehkan adalah <span class="text-success">usaha, rumah tangga, individu, pemerintah, dan organisasi swasta atau publik.</span></b-col>
                      </b-row>
                    </b-td>
                  </b-tr>

                  <b-tr class="" style="border-color:#e9e9e9 !important">
                    <b-td style="width:20px">5.</b-td>
                    <b-td>
                      <b-row class="mb-2">
                        <b-col>
                          <span class="font-weight-bold">Nama variabel boleh diawali ukuran</span>.<br>Jika variabel mengandung suatu ukuran maka nama ukuran diletakkan di awal nama variabel. Contoh ukuran dapat dilihat di <a href="#lampiran-ukuran">lampiran berikut</a>
                        </b-col>
                      </b-row>
                      <b-row>
                        <b-col cols="auto" class="pr-0">
                          <VueFeather type="check" size="18" stroke="green" stroke-width="3" style="margin-bottom:2px"></VueFeather>
                        </b-col>
                        <b-col class="pl-1"><span class="text-success">Rata-rata </span> Konsumsi Makanan</b-col>
                      </b-row>
                      <b-row>
                        <b-col cols="auto" class="pr-0">
                          <VueFeather type="check" size="18" stroke="green" stroke-width="3" style="margin-bottom:2px"></VueFeather>
                        </b-col>
                        <b-col class="pl-1"><span class="text-success">Jumlah</span> Pengeluaran</b-col>
                      </b-row>
                    </b-td>
                  </b-tr>

                  <b-tr class="" style="border-color:#e9e9e9 !important">
                    <b-td style="width:20px">6.</b-td>
                    <b-td>
                      <b-row class="mb-2">
                        <b-col>
                          <span class="font-weight-bold">Ukuran variabel tidak boleh lebih dari satu</span>. <br>Jika variabel mempunyai lebih dari satu ukuran maka variabel tersebut perlu dipecah menjadi beberapa variabel sebanyak ukurannya. Contoh ukuran dapat dilihat di <a href="#lampiran-ukuran">lampiran berikut</a>
                        </b-col>
                      </b-row>
                      <b-row>
                        <b-col cols="auto" class="pr-0">
                          <VueFeather type="check" size="18" stroke="green" stroke-width="3" style="margin-bottom:2px"></VueFeather>
                        </b-col>
                        <b-col class="pl-1">Jika variabelnya adalah Jumlah Transaksi Electronic Commerce (E-Commerce), maka ukurannya adalah <span class="text-success">jumlah</span></b-col>
                      </b-row>
                      <b-row>
                        <b-col cols="auto" class="pr-0">
                          <VueFeather type="x" size="18" stroke="red" stroke-width="3" style="margin-bottom:2px"></VueFeather>
                        </b-col>
                        <b-col class="pl-1">Jika variabelnya adalah Jumlah Transaksi Electronic Commerce (E-Commerce), maka ukurannya adalah <span class="text-danger">jumlah, nilai</span> </b-col>
                      </b-row>
                    </b-td>
                  </b-tr>

                  <b-tr class="" style="border-color:#e9e9e9 !important">
                    <b-td style="width:20px">7.</b-td>
                    <b-td>
                      <b-row class="mb-2">
                        <b-col>
                          <span class="font-weight-bold">Satuan variabel tidak boleh lebih dari satu.</span><br>
                          Satuan yang digunakan adalah satuan standar yang bersesuaian dengan ukuran yang digunakan. Contoh satuan dapat dilihat di <a href="#lampiran-satuan">lampiran berikut</a>
                        </b-col>
                      </b-row>
                      <b-row>
                        <b-col cols="auto" class="pr-0">
                          <VueFeather type="check" size="18" stroke="green" stroke-width="3" style="margin-bottom:2px"></VueFeather>
                        </b-col>
                        <b-col class="pl-1">Jika variabelnya adalah Jumlah Transaksi Electronic Commerce (E-Commerce), maka satuannya adalah <span class="text-success">transaksi</span></b-col>
                      </b-row>
                      <b-row>
                        <b-col cols="auto" class="pr-0">
                          <VueFeather type="x" size="18" stroke="red" stroke-width="3" style="margin-bottom:2px"></VueFeather>
                        </b-col>
                        <b-col class="pl-1">Jika variabelnya adalah Jumlah Transaksi Electronic Commerce (E-Commerce), maka satuannya adalah <span class="text-danger">rupiah</span> </b-col>
                      </b-row>
                    </b-td>
                  </b-tr>


                  <b-tr class="" style="border-color:#e9e9e9 !important">
                    <b-td style="width:20px">8.</b-td>
                    <b-td>
                      <b-row class="mb-2">
                        <b-col>
                          <span class="font-weight-bold">Nama variabel tidak boleh memuat periode tertentu.</span><br> 
                          Jika variabel disandingkan dengan periode akan berpotensi menimbulkan beberapa variabel yang berulang/duplikat, secara konteks merupakan variabel yang sama namun dituliskan dalam periode yang berbeda-beda.
                        </b-col>
                      </b-row>
                      <b-row>
                        <b-col cols="auto" class="pr-0">
                          <VueFeather type="check" size="18" stroke="green" stroke-width="3" style="margin-bottom:2px"></VueFeather>
                        </b-col>
                        <b-col class="pl-1">Jumlah pengeluaran</b-col>
                      </b-row>
                      <b-row>
                        <b-col cols="auto" class="pr-0">
                          <VueFeather type="x" size="18" stroke="red" stroke-width="3" style="margin-bottom:2px"></VueFeather>
                        </b-col>
                        <b-col class="pl-1">Jumlah pengeluaran <span class="text-danger">selama sebulan</span> </b-col>
                      </b-row>
                      <b-row>
                        <b-col cols="auto" class="pr-0">
                          <VueFeather type="x" size="18" stroke="red" stroke-width="3" style="margin-bottom:2px"></VueFeather>
                        </b-col>
                        <b-col class="pl-1">Jumlah pengeluaran <span class="text-danger">selama setahun</span> </b-col>
                      </b-row>
                    </b-td>
                  </b-tr>

                  <b-tr class="" style="border-color:#e9e9e9 !important">
                    <b-td style="width:20px">9.</b-td>
                    <b-td>
                      <b-row class="mb-2">
                        <b-col>
                          <span class="font-weight-bold">Nama variabel tidak memuat wilayah/cakupan wilayah tertentu.</span><br>
                          Jika variabel disandingkan dengan wilayah/cakupan wilayah tertentu akan berpotensi menimbulkan beberapa variabel yang berulang/duplikat, secara konteks merupakan variabel yang sama namun dituliskan dalam wilayah/cakupan wilayah yang berbeda-beda.
                        </b-col>
                      </b-row>
                      <b-row>
                        <b-col cols="auto" class="pr-0">
                          <VueFeather type="check" size="18" stroke="green" stroke-width="3" style="margin-bottom:2px"></VueFeather>
                        </b-col>
                        <b-col class="pl-1">Jumlah rumah sakit terdampak bencana</b-col>
                      </b-row>
                      <b-row>
                        <b-col cols="auto" class="pr-0">
                          <VueFeather type="x" size="18" stroke="red" stroke-width="3" style="margin-bottom:2px"></VueFeather>
                        </b-col>
                        <b-col class="pl-1">Jumlah rumah sakit terdampak bencana <span class="text-danger">di wilayah rawan bencana</span> </b-col>
                      </b-row>
                    </b-td>
                  </b-tr>

                  <b-tr class="" style="border-color:#e9e9e9 !important">
                    <b-td style="width:20px">10.</b-td>
                    <b-td>
                      <b-row class="mb-2">
                        <b-col>
                          <span class="font-weight-bold">Penulisan referensi disesuaikan dengan jenis sumbernya.</span> <br>Jika berasal dari website maka inputkan URL websitenya, jika publikasi maka tuliskan judul publikasinya (lebih baik jika dapat menyertakan halamannya)
                        </b-col>
                      </b-row>
                      <b-row>
                        <b-col cols="auto" class="pr-0">
                          <VueFeather type="check" size="18" stroke="green" stroke-width="3" style="margin-bottom:2px"></VueFeather>
                        </b-col>
                        <b-col class="pl-1">
                          <b-row>
                            <b-col cols="auto" class="word-wrap-break-all pr-0">https://sirusa.bps.go.id/sirusa/index.php/istilah/index </b-col>
                            <b-col cols="auto"><span class="i-badge i-badge-primary">website</span></b-col>
                          </b-row>
                        </b-col>
                      </b-row>
                      <b-row>
                        <b-col cols="auto" class="pr-0">
                          <VueFeather type="check" size="18" stroke="green" stroke-width="3" style="margin-bottom:2px"></VueFeather>
                        </b-col>
                        <b-col class="pl-1">
                          <b-row>
                            <b-col cols="auto" class="pr-0">Indikator Tujuan Pembangunan Berkelanjutan Indonesia 2021 (hlm. 123-129)</b-col>
                            <b-col cols="auto"><span class="i-badge i-badge-secondary">publikasi</span></b-col>
                          </b-row>
                        </b-col>
                      </b-row>
                      <b-row>
                        <b-col cols="auto" class="pr-0">
                          <VueFeather type="x" size="18" stroke="red" stroke-width="3" style="margin-bottom:2px"></VueFeather>
                        </b-col>
                        <b-col class="pl-1">
                          <b-row>
                            <b-col cols="auto" class="pr-0">Website BPS</b-col>
                            <b-col cols="auto" ><span class="i-badge i-badge-secondary">website</span></b-col>
                          </b-row>
                        </b-col>
                      </b-row>
                    </b-td>
                  </b-tr>
                </b-tbody>
              </b-table-simple>
            </div>
          </div>

          <div class="doc-section">
            <h3 id="indikator">Indikator</h3>
            <p>
              <span class="font-weight-bold">Menurut Peraturan Badan Pusat Statistik Nomor 4 Tahun 2020, </span> Indikator adalah variabel kendali yang dapat digunakan untuk mengukur perubahan pada sebuah kejadian atau kegiatan.
            </p>

            <p>
              Dari sumber yang lain, Indikator Statistik didefinisikan sebagai representasi data statistik pada spesifik waktu, tempat, atau karakteristik lain yang relevan (Economic Commission for Europe of the United Nations (UNECE), "Terminology on Statistical Metadata", Conference of European Statisticians Statistical Standards and Studies, No. 53, Geneva, 2000).
            </p>

            <p>
              Indikator dapat berupa angka absolut, rasio, rata-rata atau statistik lainnya. Indikator membantu para pembuat keputusan untuk mengevaluasi rencana, program pembangunan dan tujuan yang telah ditentukan. Selain itu suatu indikator statistik harus memiliki beberapa karakteristik penting, yaitu: kejelasan desain, kemampuan untuk mengukur perubahan fenomena yang sedang dipelajari, mudah dipahami dan dapat dibandingkan secara regional dan internasional. Dalam pengajuan usulan baru maupun pemutakhiran indikator terdapat beberapa atribut yang perlu diisi oleh pengusul, yaitu:
            </p>
            <div class="table-wrapper" id="atribut-indikator">
              <b-table-simple bordered>
                <b-thead>
                  <b-tr>
                    <b-th class="text-left" style="width:140px">Atribut</b-th>
                    <b-th class="text-left" >Deskripsi</b-th>
                  </b-tr>
                </b-thead>
                <b-tbody>
                  <b-tr style="border-color:#e9e9e9 !important">
                    <b-td>Nama<span style="color:red">*</span></b-td>
                    <b-td>
                      Nama indikator dapat dituangkan ke dalam satu kata tunggal, gabungan beberapa kata (frase) ataupun suatu kalimat lengkap.
                    </b-td>
                  </b-tr>
                  <b-tr style="border-color:#e9e9e9 !important">
                    <b-td>Definisi<span style="color:red">*</span></b-td>
                    <b-td>
                      Deskripsi mengenai indikator yang dapat memberikan batas atau membedakan secara jelas arti dan cakupan suatu indikator dengan indikator yang lain
                    </b-td>
                  </b-tr>
                  <b-tr style="border-color:#e9e9e9 !important">
                    <b-td>Konsep<span style="color:red">*</span></b-td>
                    <b-td>
                      Konsep yang digunakan sebagai dasar pembentukan indikator
                    </b-td>
                  </b-tr>
                  <b-tr style="border-color:#e9e9e9 !important">
                    <b-td>Ukuran</b-td>
                    <b-td>
                      Ukuran statistik yang digunakan untuk mengukur indikator seperti jumlah, rata-rata dan lainnya. Ukuran lainnya dapat dilihat di <a href="#lampiran-ukuran">lampiran berikut</a>
                    </b-td>
                  </b-tr>
                  <b-tr style="border-color:#e9e9e9 !important">
                    <b-td>Satuan</b-td>
                    <b-td>
                      Satuan adalah unit yang digunakan dalam pengukuran indikator. Satuan harus bersesuaian dengan ukuran yang digunakan. Contoh satuan persen digunakan untuk ukuran persentase. Contoh lainnya dapat dilihat di <a href="#lampiran-ukuran">lampiran berikut</a>
                    </b-td>
                  </b-tr>
                  <b-tr style="border-color:#e9e9e9 !important">
                    <b-td>Subyek<span style="color:red">*</span></b-td>
                    <b-td>
                      Digunakan untuk mengelompokkan indikator berdasarkan kategori tertentu. Kategori yang digunakan berdasarkan <i>Classification of Statistical Activities (CSA rev.1)</i>, adapun rincian kategori ini dapat dilihat di <a href="#lampiran-subyek">lampiran berikut</a>
                    </b-td>
                  </b-tr>
                  <b-tr style="border-color:#e9e9e9 !important">
                    <b-td>Manfaat<span style="color:red">*</span></b-td>
                    <b-td>
                      Deksripsi tetang manfaat yang dapat diberikan dari perhitungan indikator.
                    </b-td>
                  </b-tr>
                  <b-tr style="border-color:#e9e9e9 !important">
                    <b-td>Interpretasi<span style="color:red">*</span></b-td>
                    <b-td>
                      Deskripsi terkait bagaimana cara memaknai/menafsirkan suatu indikator sehingga mudah dipahami oleh pengguna data
                    </b-td>
                  </b-tr>
                  <b-tr style="border-color:#e9e9e9 !important">
                    <b-td>Level terkecil tersedianya data<span style="color:red">*</span></b-td>
                    <b-td>
                      Tingkatan terkecil data yang mungkin tersedia dari suatu indikator 
                    </b-td>
                  </b-tr>
                  <b-tr style="border-color:#e9e9e9 !important">
                    <b-td>Mekanisme Perhitungan Indikator<span style="color:red">*</span></b-td>
                    <b-td>
                      Penjelasan deskriptif tentang Metode atau rumus matematika yang digunakan untuk menghitung indikator
                    </b-td>
                  </b-tr>
                  <b-tr style="border-color:#e9e9e9 !important">
                    <b-td>Rumus Indikator<span style="color:red">*</span></b-td>
                    <b-td>
                      Rumus matematika yang digunakan untuk menghitung indikator
                    </b-td>
                  </b-tr>
                  <b-tr style="border-color:#e9e9e9 !important">
                    <b-td>Keterangan rumus<span style="color:red">*</span></b-td>
                    <b-td>
                      Penjelasan detail terkait setiap komponen yang terdapat pada rumus matematika yang digunakan untuk menghitung indikator
                    </b-td>
                  </b-tr>
                  <b-tr style="border-color:#e9e9e9 !important">
                    <b-td>Disaggregasi Indikator<span style="color:red">*</span></b-td>
                    <b-td>
                      Daftar variabel-variabel yang dapat digunakan untuk merincikan secara lebih detail tentang indikator yang publikasikan. Variabel yang dapat digunakan sebagai disagregasi indikator adalah variabel yang mempunyai value domain berjenis kategori seperti, wilayah (Aceh, Sumatera Utara, dst..), jenis kelamin (laki-laki dan perempuan), dst.
                    </b-td>
                  </b-tr>
                  <b-tr style="border-color:#e9e9e9 !important">
                    <b-td>Sumber referensi yang digunakan<span style="color:red">*</span></b-td>
                    <b-td>
                      Sumber referensi yang digunakan terkait dengan Indikator yang diusulkan, referensi bisa berasal dari publikasi, website maupun lainnya
                    </b-td>
                  </b-tr>
                  <b-tr class="">
                    <b-td colspan="2" class="info"><span style="color:red">*</span> Atribut yang wajib terisi</b-td>
                  </b-tr>
                </b-tbody>
              </b-table-simple>
            </div>
            <div id="rekomendasi-indikator" class="mt-4">
              <h5>Rekomendasi Pengusulan Indikator</h5>
              <b-table-simple borderless>
                <b-tbody>
                  <b-tr class="" style="border-color:#e9e9e9 !important">
                    <b-td style="width:20px">1.</b-td>
                    <b-td>
                      <b-row class="mb-2">
                        <b-col>
                          <span class="font-weight-bold">Setiap awalan kata nama Indikator harus huruf besar, kecuali kata hubung</span>
                        </b-col>
                      </b-row>
                      <b-row>
                        <b-col cols="auto" class="pr-0">
                          <VueFeather type="check" size="18" stroke="green" stroke-width="3" style="margin-bottom:2px"></VueFeather>
                        </b-col>
                        <b-col class="pl-1">Jumlah Penduduk</b-col>
                      </b-row>
                      <b-row>
                        <b-col cols="auto" class="pr-0">
                          <VueFeather type="x" size="18" stroke="red" stroke-width="3" style="margin-bottom:2px"></VueFeather>
                        </b-col>
                        <b-col class="pl-1">jumlah penduduk</b-col>
                      </b-row>
                    </b-td>
                  </b-tr>

                  <b-tr class="" style="border-color:#e9e9e9 !important">
                    <b-td style="width:20px">2.</b-td>
                    <b-td>
                      <b-row class="mb-2">
                        <b-col>
                          <span class="font-weight-bold">Nama indikator harus unik.</span><br>
                          Dari nama indikator harus dapat dibedakan antara suatu indikator dengan indikator yang lain. Jika terdapat indikator yang merupakan variasi dari suatu indikator lain, maka nama indikator tersebut bisa ditambahkan suatu konteks sehingga dapat membedakan indikator tersebut dengan indikator utamanya.
                        </b-col>
                      </b-row>
                      <b-row>
                        <b-col cols="auto" class="pr-0">
                          <VueFeather type="check" size="18" stroke="green" stroke-width="3" style="margin-bottom:2px"></VueFeather>
                        </b-col>
                        <b-col class="pl-1">Jumlah Penduduk</b-col>
                      </b-row>
                      <b-row>
                        <b-col cols="auto" class="pr-0">
                          <VueFeather type="check" size="18" stroke="green" stroke-width="3" style="margin-bottom:2px"></VueFeather>
                        </b-col>
                        <b-col class="pl-1">Jumlah Penduduk Terdampak Bencana</b-col>
                      </b-row>
                      
                    </b-td>
                  </b-tr>

                  <b-tr class="" style="border-color:#e9e9e9 !important">
                    <b-td style="width:20px">3.</b-td>
                    <b-td>
                      <b-row class="mb-2">
                        <b-col>
                          <span class="font-weight-bold">Nama indikator tidak boleh disingkat.</span> <br>Pemberian singkatan sebaiknya diberikan hanya jika singkatan bersifat umum.
                        </b-col>
                      </b-row>
                      <b-row>
                        <b-col cols="auto" class="pr-0">
                          <VueFeather type="check" size="18" stroke="green" stroke-width="3" style="margin-bottom:2px"></VueFeather>
                        </b-col>
                        <b-col class="pl-1">Indeks Pembangunan Manusia (IPM)</b-col>
                      </b-row>
                      <b-row>
                        <b-col cols="auto" class="pr-0">
                          <VueFeather type="x" size="18" stroke="red" stroke-width="3" style="margin-bottom:2px"></VueFeather>
                        </b-col>
                        <b-col class="pl-1">IPM</b-col>
                      </b-row>
                    </b-td>
                  </b-tr>

                  <b-tr class="" style="border-color:#e9e9e9 !important">
                    <b-td style="width:20px">4.</b-td>
                    <b-td>
                      <b-row class="mb-2">
                        <b-col>
                          <span class="font-weight-bold">Nama indikator harus diawali ukuran</span>.<br>Sebaiknya nama indikator diawali dengan ukuran yang digunakan seperti, jumlah, rata-rata, dan lainnya. Namun jika indikator merupakan indikator resmi yang sudah berlaku secara nasional ataupun internasional seperti Angka Kematian Ibu, Indeks Pembangunan Manusia maka tidak perlu ditambahkan ukuran di awal nama indikator. Contoh ukuran dapat dilihat di <a href="#lampiran-ukuran">lampiran berikut</a>
                        </b-col>
                      </b-row>
                      <b-row>
                        <b-col cols="auto" class="pr-0">
                          <VueFeather type="check" size="18" stroke="green" stroke-width="3" style="margin-bottom:2px"></VueFeather>
                        </b-col>
                        <b-col class="pl-1">Angka Kematian Ibu (AKI)</b-col>
                      </b-row>
                      <b-row>
                        <b-col cols="auto" class="pr-0">
                          <VueFeather type="check" size="18" stroke="green" stroke-width="3" style="margin-bottom:2px"></VueFeather>
                        </b-col>
                        <b-col class="pl-1"><span class="text-success">Persentase</span> Kontribusi Ekspor Produk Industri Berteknologi Tinggi</b-col>
                      </b-row>
                      <b-row>
                        <b-col cols="auto" class="pr-0">
                          <VueFeather type="x" size="18" stroke="red" stroke-width="3" style="margin-bottom:2px"></VueFeather>
                        </b-col>
                        <b-col class="pl-1">Kontribusi Ekspor Produk Industri Berteknologi Tinggi</b-col>
                      </b-row>
                    </b-td>
                  </b-tr>

                  <b-tr class="" style="border-color:#e9e9e9 !important">
                    <b-td style="width:20px">5.</b-td>
                    <b-td>
                      <b-row class="mb-2">
                        <b-col>
                          <span class="font-weight-bold">Nama indikator tidak boleh mengandung satuan</span>.<br>Sebaiknya satuan seperti Per 100.000 penduduk, Per 1.000 orang, dll tidak dicantumkan di nama indikator.
                        </b-col>
                      </b-row>
                      <b-row>
                        <b-col cols="auto" class="pr-0">
                          <VueFeather type="check" size="18" stroke="green" stroke-width="3" style="margin-bottom:2px"></VueFeather>
                        </b-col>
                        <b-col class="pl-1">Jumlah Insiden Tuberkolosis</b-col>
                      </b-row>
                      <b-row>
                        <b-col cols="auto" class="pr-0">
                          <VueFeather type="x" size="18" stroke="red" stroke-width="3" style="margin-bottom:2px"></VueFeather>
                        </b-col>
                        <b-col class="pl-1">Jumlah Insiden Tuberkolosis <span class="text-danger">Per 100.000 Penduduk</span></b-col>
                      </b-row>
                      <b-row>
                        <b-col cols="auto" class="pr-0">
                          <VueFeather type="x" size="18" stroke="red" stroke-width="3" style="margin-bottom:2px"></VueFeather>
                        </b-col>
                        <b-col class="pl-1">Jumlah Kejadian Malaria <span class="text-danger">Per 1000 Orang</span></b-col>
                      </b-row>
                    </b-td>
                  </b-tr>

                  <b-tr class="" style="border-color:#e9e9e9 !important">
                    <b-td style="width:20px">6.</b-td>
                    <b-td>
                      <b-row class="mb-2">
                        <b-col>
                          <span class="font-weight-bold">Ukuran indikator tidak boleh lebih dari satu</span>. <br>Jika indikator mempunyai lebih dari satu ukuran maka indikator tersebut perlu dipecah menjadi beberapa indikator sesuai dengan banyaknya ukuran. Contoh ukuran dapat dilihat di <a href="#lampiran-ukuran">lampiran berikut</a>
                        </b-col>
                      </b-row>
                      <b-row>
                        <b-col cols="auto" class="pr-0">
                          <VueFeather type="check" size="18" stroke="green" stroke-width="3" style="margin-bottom:2px"></VueFeather>
                        </b-col>
                        <b-col class="pl-1">Jika indikatornya adalah persentase penduduk yang hidup di bawah garis kemiskinan nasional, maka ukurannya adalah <span class="text-success">persentase</span></b-col>
                      </b-row>
                      <b-row>
                        <b-col cols="auto" class="pr-0">
                          <VueFeather type="x" size="18" stroke="red" stroke-width="3" style="margin-bottom:2px"></VueFeather>
                        </b-col>
                        <b-col class="pl-1">Jika indikatornya adalah persentase penduduk yang hidup di bawah garis kemiskinan nasional, maka ukurannya adalah <span class="text-danger">jumlah, persentase</span></b-col>
                      </b-row>
                    </b-td>
                  </b-tr>
                  
                  <b-tr class="" style="border-color:#e9e9e9 !important">
                    <b-td style="width:20px">7.</b-td>
                    <b-td>
                      <b-row class="mb-2">
                        <b-col>
                          <span class="font-weight-bold">Satuan indikator tidak boleh lebih dari satu.</span><br>
                          Satuan yang digunakan adalah satuan standar yang bersesuaian dengan ukuran yang digunakan. Contoh satuan dapat dilihat di <a href="#lampiran-satuan">lampiran berikut</a>
                        </b-col>
                      </b-row>
                      <b-row>
                        <b-col cols="auto" class="pr-0">
                          <VueFeather type="check" size="18" stroke="green" stroke-width="3" style="margin-bottom:2px"></VueFeather>
                        </b-col>
                        <b-col class="pl-1">Jika indikatornya adalah persentase penduduk yang hidup di bawah garis kemiskinan nasional, maka satuannya adalah <span class="text-success">Persen</span></b-col>
                      </b-row>
                      <b-row>
                        <b-col cols="auto" class="pr-0">
                          <VueFeather type="x" size="18" stroke="red" stroke-width="3" style="margin-bottom:2px"></VueFeather>
                        </b-col>
                        <b-col class="pl-1">Jika indikatornya adalah persentase penduduk yang hidup di bawah garis kemiskinan nasional, maka satuannya adalah <span class="text-danger">Orang</span> </b-col>
                      </b-row>
                      <b-row>
                        <b-col cols="auto" class="pr-0">
                          <VueFeather type="x" size="18" stroke="red" stroke-width="3" style="margin-bottom:2px"></VueFeather>
                        </b-col>
                        <b-col class="pl-1">Jika indikatornya adalah persentase penduduk yang hidup di bawah garis kemiskinan nasional, maka satuannya adalah <span class="text-danger">Orang, Persen</span> </b-col>
                      </b-row>
                    </b-td>
                  </b-tr>


                  <b-tr class="" style="border-color:#e9e9e9 !important">
                    <b-td style="width:20px">8.</b-td>
                    <b-td>
                      <b-row class="mb-2">
                        <b-col>
                          <span class="font-weight-bold">Nama indikator tidak boleh memuat disaggregasi tertentu.</span><br> 
                          Jika indikator disandingkan dengan disaggregasi tertentu (wilayah, jenis kealmin, kelompok umur, dst..) akan berpotensi menimbulkan beberapa indikator yang berulang/duplikat, secara konteks merupakan indikator yang sama namun dituliskan berdasarkan disaggregasi yang berbeda-beda.
                        </b-col>
                      </b-row>
                      <b-row>
                        <b-col cols="auto" class="pr-0">
                          <VueFeather type="check" size="18" stroke="green" stroke-width="3" style="margin-bottom:2px"></VueFeather>
                        </b-col>
                        <b-col class="pl-1">Persentase penduduk yang hidup di bawah garis kemiskinan nasional.</b-col>
                      </b-row>
                      <b-row>
                        <b-col cols="auto" class="pr-0">
                          <VueFeather type="x" size="18" stroke="red" stroke-width="3" style="margin-bottom:2px"></VueFeather>
                        </b-col>
                        <b-col class="pl-1">Persentase penduduk yang hidup di bawah garis kemiskinan nasional<span class="text-danger"> menurut jenis wilayah.</span> </b-col>
                      </b-row>
                      <b-row>
                        <b-col cols="auto" class="pr-0">
                          <VueFeather type="x" size="18" stroke="red" stroke-width="3" style="margin-bottom:2px"></VueFeather>
                        </b-col>
                        <b-col class="pl-1">Persentase penduduk yang hidup di bawah garis kemiskinan nasional<span class="text-danger"> menurut jenis wilayah dan jenis kelamin.</span> </b-col>
                      </b-row>
                      <b-row>
                        <b-col cols="auto" class="pr-0">
                          <VueFeather type="x" size="18" stroke="red" stroke-width="3" style="margin-bottom:2px"></VueFeather>
                        </b-col>
                        <b-col class="pl-1">Persentase penduduk yang hidup di bawah garis kemiskinan nasional<span class="text-danger"> menurut jenis wilayah, jenis kelamin dan kelompok umur.</span> </b-col>
                      </b-row>
                    </b-td>
                  </b-tr>

                  <b-tr class="" style="border-color:#e9e9e9 !important">
                    <b-td style="width:20px">9.</b-td>
                    <b-td>
                      <b-row class="mb-2">
                        <b-col>
                          <span class="font-weight-bold">Penulisan referensi disesuaikan dengan jenis sumbernya.</span> <br>Jika berasal dari website maka inputkan URL websitenya, jika publikasi maka tuliskan judul publikasinya (lebih baik jika dapat menyertakan halamannya)
                        </b-col>
                      </b-row>
                      <b-row>
                        <b-col cols="auto" class="pr-0">
                          <VueFeather type="check" size="18" stroke="green" stroke-width="3" style="margin-bottom:2px"></VueFeather>
                        </b-col>
                        <b-col class="pl-1">
                          <b-row>
                            <b-col cols="auto" class="word-wrap-break-all pr-0">https://sirusa.bps.go.id/sirusa/index.php/istilah/index </b-col>
                            <b-col cols="auto"><span class="i-badge i-badge-primary">website</span></b-col>
                          </b-row>
                        </b-col>
                      </b-row>
                      <b-row>
                        <b-col cols="auto" class="pr-0">
                          <VueFeather type="check" size="18" stroke="green" stroke-width="3" style="margin-bottom:2px"></VueFeather>
                        </b-col>
                        <b-col class="pl-1">
                          <b-row>
                            <b-col cols="auto" class="pr-0">Indikator Tujuan Pembangunan Berkelanjutan Indonesia 2021 (hlm. 123-129)</b-col>
                            <b-col cols="auto"><span class="i-badge i-badge-secondary">publikasi</span></b-col>
                          </b-row>
                        </b-col>
                      </b-row>
                      <b-row>
                        <b-col cols="auto" class="pr-0">
                          <VueFeather type="x" size="18" stroke="red" stroke-width="3" style="margin-bottom:2px"></VueFeather>
                        </b-col>
                        <b-col class="pl-1">
                          <b-row>
                            <b-col cols="auto" class="pr-0">Website BPS</b-col>
                            <b-col cols="auto" ><span class="i-badge i-badge-secondary">website</span></b-col>
                          </b-row>
                        </b-col>
                      </b-row>
                    </b-td>
                  </b-tr>
                </b-tbody>
              </b-table-simple>
            </div>
            
          </div>

          <div id="lampiran">
            <div class="doc-section">
              <h3 id="lampiran-ukuran">Ukuran</h3>
              <p>
                Ukuran yang dapat digunakan untuk mengukur variabel atau indikator mencakup namun tidak terbatas pada:
              </p>
              <div class="table-wrapper" id="atribut-indikator">
                <b-table-simple bordered>
                  <b-thead>
                    <b-tr>
                      <b-th class="text-center" style="width:40px">No.</b-th>
                      <b-th class="text-left" style="width:140px">Nama Ukuran</b-th>
                      <b-th class="text-left" >Deskripsi</b-th>
                    </b-tr>
                  </b-thead>
                  <b-tbody>
                    <b-tr>
                      <b-td class="text-center">1.</b-td>
                      <b-td>Rasio, Rate, dan Proporsi</b-td>
                      <b-td>
                        <b-row class="mb-2">
                          <b-col>
                            Adalah bilangan yang menyatakan perbandingan antara dua nilai; yaitu hasil pembagian x dengan y.
                          </b-col>
                        </b-row>
                        <span class="font-weight-bold">Contoh:</span>
                        <b-row>
                          <b-col style="max-width:30px" class="pr-0">1. </b-col>
                          <b-col class="pl-1">Gini Rasio (jumlah laki-laki / jumlah perempuan)</b-col>
                        </b-row>
                        <b-row>
                          <b-col style="max-width:30px"  class="pr-0">2. </b-col>
                          <b-col class="pl-1">kepadatan penduduk (jumlah penduduk/ Luas wilayah)</b-col>
                        </b-row>
                      </b-td>
                    </b-tr>
                    <b-tr>
                      <b-td class="text-center">2.</b-td>
                      <b-td>Persentase</b-td>
                      <b-td>
                        Adalah <span class="font-weight-bold">kasus khusus rasio</span>  di mana hasil perhitungan rasio dikalikan dengan 100 untuk mendapatkan persentasenya.<br><br>
                        <span class="font-weight-bold">Contoh:</span> (Jumlah laki-laki / jumlah penduduk) x 100%.
                      </b-td>
                    </b-tr>
                    <b-tr>
                      <b-td class="text-center">3.</b-td>
                      <b-td>Indeks</b-td>
                      <b-td>
                        Adalah indikator statistik yang mengukur perubahan relatif yang terjadi pada suatu fenomena, harga, kuantitas, nilai atau upah tertentu yang dikaitkan dengan suatu dasar tertentu (bisa periode waktu tertentu atau lokasi geografis tertentu).<br><br>
                        <span class="font-weight-bold">Contoh:</span> Indeks Harga Konsumen. 
                      </b-td>
                    </b-tr>
                    <b-tr>
                      <b-td class="text-center">4.</b-td>
                      <b-td>Rata-rata ( Rata-rata aritmatika) </b-td>
                      <b-td>
                        Rata-rata aritmatika adalah salah satu ukuran tendensi sentral yang paling penting, yang paling sering digunakan dalam berbagai kasus. Ini umumnya dikenal sebagai jumlah nilai pengamatan dibagi dengan jumlah total pengamatan.
                        <br><br>
                        <span class="font-weight-bold">Contoh:</span> Rata-rata pendapat keluarga.
                      </b-td>
                    </b-tr>
                    <b-tr>
                      <b-td class="text-center">5.</b-td>
                      <b-td>Median</b-td>
                      <b-td>
                        Median dari n pengukuran atau pengamatan x<sub>1</sub>, x<sub>2</sub>, ,..., x<sub>n</sub>, adalah nilai pengamatan yang terletak di tengah gugus data setelah data tersebut diurutkan. Apabila banyaknya pengamatan (n) ganjil, median terletak tepat ditengah gugus data, sedangkan bila n genap, median diperoleh dengan cara interpolasi yaitu rata-rata dari dua data yang berada di tengah gugus data
                      </b-td>
                    </b-tr>
                    
                    <b-tr>
                      <b-td class="text-center">6.</b-td>
                      <b-td>Probabilitas</b-td>
                      <b-td>
                        Adalah ukuran matematis dari peluang terjadinya suatu peristiwa. Ini adalah kasus khusus rasio ketika penyebutnya adalah jumlah total ruang sampel pada awal periode observatorium. 
                        <br><br>
                        <span class="font-weight-bold">Contoh:</span> 10 orang meninggal dalam satu tahun dari komunitas yang terdiri dari 1000 orang pada awal tahun. Probabilitas kematian selama tahun itu adalah 10 1000 atau 0,01
                      </b-td>
                    </b-tr>
                    <b-tr>
                      <b-td class="text-center">7.</b-td>
                      <b-td>Nilai Maksimum</b-td>
                      <b-td>
                        Nilai tertinggi dari distribusi statistik suatu variabel
                      </b-td>
                    </b-tr>
                    <b-tr>
                      <b-td class="text-center">8.</b-td>
                      <b-td>Nilai Minimum</b-td>
                      <b-td>
                        Nilai terkecil dari distribusi statistik suatu variabel
                      </b-td>
                    </b-tr>
                    <b-tr>
                      <b-td class="text-center">9.</b-td>
                      <b-td>Rentang (Range)</b-td>
                      <b-td>
                        Selisih antara nilai maksimum dan minimum suatu variabel
                      </b-td>
                    </b-tr>
                    <b-tr>
                      <b-td class="text-center">10.</b-td>
                      <b-td>Varian</b-td>
                      <b-td>
                        Rata-rata kuadrat deviasi nilai dari rata-rata aritmatikanya
                      </b-td>
                    </b-tr>
                    <b-tr>
                      <b-td class="text-center">11.</b-td>
                      <b-td>Standar Deviasi</b-td>
                      <b-td>
                        Akar kuadrat dari varians.
                      </b-td>
                    </b-tr>
                  </b-tbody>
                </b-table-simple>
              </div>
            </div>
            <div class="doc-section">
              <h3 id="lampiran-subyek">Subyek</h3>
              <p>
                Subyek digunakan untuk mengklasifikasikan variabel, indikator, kegiatan statistik dan lainnya. subyek yang digunakan mengacu pada Classification Of Statistical Activities (CSA Rev. 1 - October 2009).
              </p>

              <div class="table-wrapper">
                <b-table-simple bordered>
                  <b-thead>
                    <b-tr>
                      <b-th class="text-left" colspan="4">Subyek</b-th>
                      <b-th class="text-left" >Deskripsi</b-th>
                    </b-tr>
                  </b-thead>
                  <b-tbody>
                    <b-tr v-for="(subject, index) in subjects" :key="index">

                      
                      <!-- first col for level 2 & 3 -->
                      <td v-if="subject.level>1"
                        :style="index != subjects.length-1  && subjects[index+1].level != 1 ? 'border-bottom:1px solid transparent':''" 
                        >
                      </td>
                      <!-- second col for level 3 -->
                      <td v-if="subject.level>2"
                        :style="index != subjects.length-1  && subjects[index+1].level ==3 ? 'border-bottom:1px solid transparent':''" 
                        >
                      </td>

                      <td 
                        class="text-center font-weight-bold" 
                        style="width:32px;" :style="subject.level==1 || (subject.level==2 && index != subjects.length-1  && subjects[index+1].level ==3 )? 'border-bottom:1px solid transparent':''"
                      >
                        {{subject.code}}
                      </td>
                      <b-td :colspan="subject.level==1 ? 3:(subject.level==2 ? 2:1)">{{subject.name}}</b-td>
                      <b-td>
                        {{subject.description}}
                        <div class="mt-3 " v-if="subject.excludes.length>0">
                          <div class="font-weight-bold">Tidak termasuk: </div>
                          <div v-for="(exclude,index) in subject.excludes" :key="index">
                            <b-row
                              class="mx-0 py-1" :class="index != 0 || (subject.excludes.length==1 && index1 !=0) ? 'border-top':''" 
                              v-for="(item,index1) in exclude.items" :key="index1"
                            >
                              <b-col cols="auto" class="px-1">-</b-col>
                              <b-col class="px-1">
                                <b-row>
                                  <b-col> {{item}}</b-col>
                                  <b-col cols="12" class="i-text-12" style="color:#8b8b8b" v-if="exclude.subject"> 
                                    ({{exclude.subject.code}} - {{exclude.subject.name}})
                                  </b-col>
                                </b-row>
                              </b-col>
                            </b-row>
                          </div>
                        </div>
                      </b-td>
                    </b-tr>
                    <!-- <b-tr>
                      <td class="text-center font-weight-bold" style="width:32px;border-bottom:1px solid transparent">1.</td>
                      <b-td colspan="2">
                        Statistik Demografi dan Sosial
                      </b-td>
                      <b-td>
                        Domain yang berkaitan langsung dengan aktivitas subjek matter untuk menghasilkan data statistik demograsi dan sosial
                      </b-td>
                    </b-tr>
                    <b-tr>
                      <td style="border-bottom:1px solid transparent" ></td>
                      <td class="text-center font-weight-bold" style="width:20px">1.1</td>
                      <b-td>
                        Kependudukan dan Migrasi
                      </b-td>
                      <b-td>
                        mencakup kegiatan statistik yang berkaitan dengan kependudukan dan demografi, topik-topik seperti demografi, statistik vital, struktur dan pertumbuhan populasi, proyeksi demografis, keluarga dan rumah tangga (pernikahan, perceraian, ukuran rumah tangga), migrasi, pengungsi dan pencari suaka. 
                        <br><br>
                        <span class="font-weight-bold">Tidak termasuk: </span> Penyebab kematian (1.4 - kesehatan)
                      </b-td>
                    </b-tr> -->
                    
                  </b-tbody>
                </b-table-simple>
              </div>
            </div>
          </div>
        </div>
        
        

      </b-col>
      
    </b-row>
  </div>

</template>
<script>
import "@/assets/scss/indah.scss";
import Breadcrumbs from "@/components/Breadcrumbs";
import VueFeather from 'vue-feather';
import SubjectField from './data/subject_field.js';
export default {
  components: {
    VueFeather,
    Breadcrumbs
  },
  data(){
    return{
      breadcrumbs: [
        {
          text: "Home",
          href: "/old-sds",
        },
        {
          text: "Panduan penggunaan standar data statistik",
          href:'',
          active: true,
        },
      ],
      menu:[
        {
          id:1,
          name:'Selamat Datang',
          subMenuVisible:true,
          subMenu:[],
        },
        {
          id:1,
          name:'Standar Data Statistik Nasional',
          subMenuVisible:true,
          subMenu:[],
        },
        {
          id:1,
          name:'Usulan SDS',
          subMenuVisible:true,
          subMenu:[
            {
              id:1,
              name:'Aktor Pengusul',
              subMenuVisible:false,
              subMenu:[]
            },
            {
              id:1,
              name:'Alur pengusulan',
              subMenuVisible:false,
              subMenu:[]
            },
            {
              id:1,
              name:'Konsep',
              subMenuVisible:false,
              subMenu:[]
            },
            {
              id:1,
              name:'Variabel',
              subMenuVisible:false,
              subMenu:[]
            },
            {
              id:1,
              name:'Indikator',
              subMenuVisible:false,
              subMenu:[]
            }
          ]
        },
        {
          id:1,
          name:'Pemeriksaan SDS',
          subMenuVisible:true,
          subMenu:[
            {
              id:1,
              name:'Aktor Pemeriksa',
              subMenuVisible:false,
              subMenu:[]
            },
            {
              id:1,
              name:'Status Pemeriksaan',
              subMenuVisible:false,
              subMenu:[]
            },
            {
              id:1,
              name:'Alur Pemeriksaan',
              subMenuVisible:false,
              subMenu:[]
            },
          ]
        },
        {
          id:1,
          name:'Laporan',
          subMenuVisible:true,
          subMenu:[]
        },
        
      ],
      active_el:null,
      subjects: SubjectField,
    }
  },
  created() {
    this.$root.$on('bv::scrollspy::activate', this.onActivate)
  },
  mounted(){
  },
  computed:{
    
  },
  
  methods:{
    onActivate(target) {
      this.active_el = target.replace('#','');

    },
    isActive(id){
      return this.active_el == id ? true : false;
    },
    scrollIntoView(event) {
      event.preventDefault()
      const href = event.target.getAttribute('href')
      const el = href ? document.querySelector(href) : null
      
      if (el) {
        console.log(el.offsetTop)
          window.scrollTo(0,el.offsetTop-20)
      }
    },
    scrollTo(href){
      const el = href ? document.querySelector(href) : null
      
      if (el) {
        console.log(el.offsetTop)
          window.scrollTo(0,el.offsetTop-20)
      }
    }
  }
}
</script>